import React, {useState, useEffect} from 'react'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import InvertColorsIcon from '@material-ui/icons/InvertColors';
import FastForwardIcon from '@material-ui/icons/FastForward';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import Brightness5Icon from '@material-ui/icons/Brightness5';
import VisibilityIcon from '@material-ui/icons/Visibility';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Loader from './Loader';
import {Link} from 'react-router-dom'
const Navbar = ({ tempInfo }) => {
  const [weatherState, setWeatherState] = useState("");
  const {
    temp,
    feels_like,
    temp_min,
    temp_max,
    pressure,
    humidity,
    weatherday,
    name,
    speed,
    sunrise,
    sunset,
    country,
    visibility,
  } = tempInfo;


  let sec = sunset;
  let date = new Date(sec * 1000);
  let timeStr = `${date.getHours()}:${date.getMinutes()}`;


  let secs = sunrise;
  let dates = new Date(secs * 1000);
  let timeStrs = `${dates.getHours()}:${dates.getMinutes()}`;


   useEffect(() => {
      if(weatherday) {
        switch (weatherday) {
          case "Clouds":
              setWeatherState("cloud1.png");
            break;
            case "Thunderstorm":
              setWeatherState("thunder1.png");
            break;
            case "Drizzle":
              setWeatherState("rain1.png");
            break;
            case "Haze":
              setWeatherState("haze1.png");
            break;
            case "Rain":
              setWeatherState("rain1.png");
            break;
          default:
            setWeatherState("sun1.png");
            break;
        }
      }
   }, [weatherday]);



    return (
        <>
         <div className="main-container">
           <img className="home_image" src={weatherState} height="100%" width="100%" alt="."/>
           
            <div className="wetCard">
              <div className="wetCard1"><font color="#0e3066">{temp? temp : <Loader/>}°C</font></div>
              <div className="wetCard2">{name} ({country})<br></br>{new Date().toLocaleString()}</div>
              <div className="wetCard3">{weatherday}</div>

            <div className="details">
              <center><span></span><br></br>
              <h4>Weather details</h4></center><br></br>
              <div className="details1">
                <div className="detailsa"><AcUnitIcon/></div>
                <div className="detailsb">Feels like</div>
                <div className="detailsc">{feels_like}°C</div>     
              </div> <br></br>

              <div className="details1">
                <div className="detailsa">< ArrowDownwardIcon/></div>
                <div className="detailsb">MIN</div>
                <div className="detailsc">{temp_min}°C</div>     
              </div><br></br>

              <div className="details1">
                <div className="detailsa">< ArrowUpwardIcon/></div>
                <div className="detailsb">MAX</div>
                <div className="detailsc">{temp_max}°C</div>     
              </div><br></br>

              <div className="details1">
                <div className="detailsa"><ArrowDropDownIcon/></div>
                <div className="detailsb">Pressure</div>
                <div className="detailsc">{pressure}Pa</div>     
              </div><br></br>

              <div className="details1">
                <div className="detailsa"><InvertColorsIcon /></div>
                <div className="detailsb">Humidity</div>
                <div className="detailsc">{humidity}%</div>     
              </div><br></br>

              <div className="details1">
                <div className="detailsa"><FastForwardIcon/></div>
                <div className="detailsb">Wind speed</div>
                <div className="detailsc">{speed}km/h</div>     
              </div><br></br>

              <div className="details1">
                <div className="detailsa">< Brightness7Icon/></div>
                <div className="detailsb">Sunrise</div>
                <div className="detailsc">{timeStrs}</div>     
              </div><br></br>

              <div className="details1">
                <div className="detailsa"><Brightness5Icon/></div>
                <div className="detailsb">Sunset</div>
                <div className="detailsc">{timeStr}</div>     
              </div><br></br>

              <div className="details1">
                <div className="detailsa"><VisibilityIcon/></div>
                <div className="detailsb">visibility</div>
                <div className="detailsc">{visibility/1000}km</div>     
              </div><br></br>

              <div className="details1">
                <div className="detailsa"><LocationOnIcon/></div>
                <div className="detailsb">country</div>
                <div className="detailsc">{country}</div>     
              </div><br></br>
              <center>Made with ❤️ by <a href="https://github.com/Decoder6125">decoder</a></center>
              <br></br>





            </div>

            

              
            </div>

        







        </div>
       


       

        </>
    )
}

export default Navbar
